import { useEffect } from "react";

type UseEmbeddedMachineBridgeParams = {
  targetMachineId: string;
  webClientId: string;
  setTargetMachineId: React.Dispatch<React.SetStateAction<string>>;
  setOperatorName: React.Dispatch<React.SetStateAction<string>>;
  setOperatorId: React.Dispatch<React.SetStateAction<string>>;
};

export function useEmbeddedMachineBridge({
  targetMachineId,
  webClientId,
  setTargetMachineId,
  setOperatorName,
  setOperatorId,
}: UseEmbeddedMachineBridgeParams) {
  useEffect(() => {
    // 保持旧协议约定，把当前目标设备和 web client id 同步到全局窗口对象上。
    (window as any).__HB_TARGET_MACHINE_ID__ = targetMachineId;
    (window as any).__HB_WEB_CLIENT_ID__ = webClientId;
  }, [targetMachineId, webClientId]);

  useEffect(() => {
    // 云端嵌入模式通过 postMessage 切换目标设备，这里保持原有的桥接行为不变。
    const onMessage = (evt: MessageEvent) => {
      const payload = evt?.data;
      if (!payload || typeof payload !== "object") {
        return;
      }
      const data = payload as Record<string, unknown>;
      if (data.type !== "OPEN_MACHINE") {
        return;
      }

      const machineId = String(data.machineId || "").trim();
      if (!machineId) {
        return;
      }

      setTargetMachineId(machineId);

      const operatorName = String(data.operatorName || data.operator || data.username || "").trim();
      const operatorId = String(data.operatorId || data.userId || "").trim();

      if (operatorName) {
        setOperatorName(operatorName);
      }
      if (operatorId) {
        setOperatorId(operatorId);
      }
    };

    window.addEventListener("message", onMessage);

    try {
      if (window.parent && window.parent !== window) {
        window.parent.postMessage({ type: "CLOUD_WEB_READY", machineId: targetMachineId }, "*");
      }
    } catch (error) {
      // 嵌入环境偶发不允许访问 parent 时保持静默，行为与原实现一致。
    }

    return () => window.removeEventListener("message", onMessage);
  }, [targetMachineId, setOperatorId, setOperatorName, setTargetMachineId]);
}
